import styled from 'styled-components';
import colors from 'styles/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: ${colors.$black};
  font-size: 14px;
  line-height: 1.4;

  .perfil-intro {
    margin: 0;
    color: ${colors.$gray800};
    letter-spacing: -0.28px;
  }

  .perfil-vazio {
    margin: 0;
    color: ${colors.$gray800};

    button {
      margin-left: 6px;
      padding: 0;
      border: none;
      background: none;
      color: ${colors.$primary};
      font-size: 14px;
      cursor: pointer;
    }
  }

  .perfil-bloco {
    padding: 16px;
    background: ${colors.$white};
    border: 1px solid ${colors.$gray500};
    border-radius: 4px;

    h4 {
      display: flex;
      align-items: center;
      gap: 8px;
      margin: 0 0 8px;
      font-size: 15px;
      font-weight: 700;
      letter-spacing: -0.3px;
    }
  }

  .perfil-contagem {
    padding: 1px 8px;
    background: ${colors.$gray200};
    border-radius: 10px;
    color: ${colors.$gray800};
    font-size: 12px;
    font-weight: 600;
  }

  .perfil-segmento {
    margin: 0;
    color: ${colors.$gray800};
  }

  .perfil-chips {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;
  }

  .perfil-chip {
    padding: 3px 10px;
    background: ${colors.$gray100};
    border: 1px solid ${colors.$gray500};
    border-radius: 12px;
    font-size: 12px;
  }

  .perfil-chip--uf {
    min-width: 38px;
    text-align: center;
    font-weight: 600;
    letter-spacing: 0.4px;
  }

  .perfil-itens {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      gap: 12px;
      padding: 7px 0;
      border-bottom: 1px solid ${colors.$gray200};
    }

    li:last-child {
      border-bottom: none;
    }
  }

  .perfil-item-desc {
    flex: 1;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .perfil-item-meta {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
    color: ${colors.$gray700};
    font-size: 12px;

    em {
      font-style: normal;
      padding: 1px 6px;
      background: ${colors.$gray100};
      border-radius: 8px;
    }
  }

  .perfil-paginacao {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-top: 12px;
    color: ${colors.$gray700};
    font-size: 13px;

    button {
      padding: 6px 12px;
      background: ${colors.$white};
      border: 1px solid ${colors.$gray500};
      border-radius: 4px;
      color: ${colors.$primary};
      font-size: 13px;
      cursor: pointer;

      &:disabled {
        color: ${colors.$gray600};
        cursor: default;
      }
    }
  }

  .perfil-rodape {
    margin: 0;
    color: ${colors.$gray700};
    font-size: 13px;
  }

  .perfil-aviso {
    margin: 0;
    padding: 10px 12px;
    background: ${colors.$gray100};
    border-left: 3px solid ${colors.$primary};
    border-radius: 4px;
    color: ${colors.$gray800};
    font-size: 13px;
  }

  .perfil-link {
    padding: 0;
    border: none;
    background: none;
    color: ${colors.$primary};
    font-size: 13px;
    cursor: pointer;
  }

  h4 .perfil-link {
    margin-left: auto;
  }

  .perfil-btn-salvar {
    padding: 6px 14px;
    background: ${colors.$primary};
    border: none;
    border-radius: 4px;
    color: ${colors.$white};
    font-size: 13px;
    cursor: pointer;

    &:disabled {
      opacity: 0.6;
      cursor: default;
    }
  }

  .perfil-acoes-linha {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 12px;
  }

  .perfil-chips--seletor {
    gap: 4px;
  }

  .perfil-uf-opt {
    min-width: 38px;
    padding: 3px 8px;
    background: ${colors.$white};
    border: 1px solid ${colors.$gray500};
    border-radius: 12px;
    color: ${colors.$gray800};
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.4px;
    cursor: pointer;
  }

  .perfil-uf-opt--on {
    background: ${colors.$primary};
    border-color: ${colors.$primary};
    color: ${colors.$white};
  }

  .perfil-item-acao {
    display: flex;
    align-items: center;
    padding: 2px;
    border: none;
    background: none;
    color: ${colors.$gray700};
    cursor: pointer;

    .material-icons {
      font-size: 18px;
    }

    &:hover {
      color: ${colors.$primary};
    }

    &:disabled {
      opacity: 0.5;
      cursor: default;
    }
  }

  .perfil-item-acao--excluir:hover {
    color: ${colors.$red};
  }

  .perfil-item-edicao {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;

    input {
      flex: 1;
      padding: 6px 10px;
      border: 1px solid ${colors.$gray500};
      border-radius: 4px;
      font-size: 14px;
    }
  }
`;

export default Container;
